import {MarketStatsStyles} from "../../../../../common/ts/components/charts/MarketStatsChart";
import {isMobileDevice} from "../../../device";
import {MarketStatsInitializer} from "../../../../../common/ts/components/core/market-stats/MarketStatsInitializer";

export function generateStyles(isMobile: boolean): MarketStatsStyles {
    return {
       lineColor: '#0080FF',
       fillColor: '#0080FF',
       axisBorderColor: '#4A4A4A',
       scalesLabelColor: '#7A7A7A',
       tickPadding: isMobile ? 0 : 10,
       tooltipTitleFontSize: isMobile ? 10 : 14,
       tooltipBodyFontSize: isMobile ? 12 : 16,
       chartType: 'bar',
       pointRadius: isMobile ? 5 : 8,
       pointColor: '#FFFFFF',
       pointHoverColor: '#0080FF',
       xAxisRotation: isMobile ? 90 : false,
       yAxisRotation : false,
       barThickness: "flex",
       barBorderRadius: isMobile ? 60 : 8,
   }
}

window.onload = () => {
   new MarketStatsInitializer((device: string) => {
      return generateStyles(isMobileDevice(device))
   }).init();
}
